import ServiceCard from '@/components/ServiceCard'

const services = [
  { name: 'Consulta general', icon: 'ph ph-stethoscope' },
  { name: 'Primera consulta', icon: 'ph ph-clipboard-text' },
  { name: 'Consulta de control', icon: 'ph ph-calendar-check' },
  { name: 'Consulta de urgencia', icon: 'ph ph-first-aid' },
  { name: 'Consulta a domicilio', icon: 'ph ph-house' },
  { name: 'Segunda opinión veterinaria', icon: 'ph ph-users' },
  { name: 'Certificado de salud', icon: 'ph ph-certificate' },
  { name: 'Certificado para viaje', icon: 'ph ph-airplane' },
  { name: 'Emisión de certificados veterinarios', icon: 'ph ph-file-text' },
]

function Consultas() {
  return (
    <div className="relative min-h-screen bg-background">
      <div className="watermark" aria-hidden="true"></div>
      <section className="page-hero h-64 md:h-80 flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario realizando consulta clínica a un perro"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
        <h1 className="relative text-3xl md:text-4xl font-bold text-white">Consultas</h1>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <ServiceCard
                key={service.name}
                title={service.name}
                icon={service.icon}
                href="/contacto"
                index={index}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Consultas